import React from "react";
import { useSelector } from "react-redux";
import PT from "prop-types";
import get from "lodash/get";
import { UpdateOnInterval } from "@quintype/components";
import { getLiveStoryData } from "../../../../api/utils";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import { BreadCrumbs} from "../atoms";
import AdWrapper from "../atoms/AdWrapper";
import LiveBlogTemplate from "./LiveblogTemplate";
import { getQueryParamsForArticleApi } from "../../utils/utils";

import "./live-blog.m.css";

function LiveBlog({ story }) {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  const params = getQueryParamsForArticleApi(currentPath);
  const template = get(story, ["story-template"], "");
  const adsConfig = get(qtState, ["config", "ads-config"], {});
  const storyPageBottomAd = get(adsConfig, ["slots", "live_blog_bottom_ad"], {});
  const storyId = get(story, ["id"], "");
  const liveStoryData = () => getLiveStoryData(storyId);

  return (
    <>
      <div className="story-grid" styleName="story-grid-container">
        <BreadCrumbs currentPath={story?.slug} />
        <UpdateOnInterval dataLoader={liveStoryData} interval={20000} initData={{ story: story }}>
          {({ data }) => {
            const { story } = data;
            return <LiveBlogTemplate story={story} />;
          }}
        </UpdateOnInterval>
        {/* BOTTOM AD */}
        {storyPageBottomAd.ad_unit && (
          <AdWrapper
            adStyleName="story-page-ad-slot"
            id={`${template}-bottom-ad`}
            path={storyPageBottomAd.ad_unit}
            size={storyPageBottomAd.sizes}
            viewPortSizeMapping={storyPageBottomAd.view_port_size_mapping}
            isLhsAd={true}
          />
        )}
        <div styleName="up-next-wrapper">
          <div styleName="up-next-title">
            <span>Up Next</span>
            <SvgIconHandler type="point-arrow" width="24px" height="24px" />
          </div>
        </div>
      </div>
    </>
  );
}

LiveBlog.propTypes = {
  story: PT.object,
  config: PT.object,
};

export default LiveBlog;
